// Shared status label and style maps used across Requests, Annotate, ARM, and RAS pages.
// Keys cover both raw API snake_case values and display label strings so either form resolves correctly.
export const STATUS_LABEL = {
    in_discussion: "Needs Meeting",
    needs_meeting: "Needs Meeting",
    in_review: "In Review",
    approved: "Approved",
    approved_with_changes: "Approved With Changes",
    rejected: "Rejected",
    draft: "Draft",
    revise_and_resubmit: "Revise and Resubmit",
    design_in_progress: "Design In Progress",
    design_completed: "Design Completed",
    review_in_progress: "Review In Progress",
    in_progress: "In Progress",
    cancelled: "Cancelled",
    hold: "Hold",
    deleted: "Deleted",
    completed: "Completed",
    start_review: "Start Review",
};
export const STATUS_STYLE = {
    // Needs Meeting
    in_discussion: { background: "#DCEAFC", color: "#0D4996" },
    needs_meeting: { background: "#DCEAFC", color: "#0D4996" },
    "Needs Meeting": { background: "#DCEAFC", color: "#0D4996" },
    // Revise and Resubmit
    revise_and_resubmit: { background: "#F7FCDC", color: "#61710A" },
    "Revise and Resubmit": { background: "#F7FCDC", color: "#61710A" },
    // Approved With Changes
    approved_with_changes: { background: "#F1FEDB", color: "#3C5E03" },
    "Approved With Changes": { background: "#F1FEDB", color: "#3C5E03" },
    // Approved
    approved: { background: "#E0FCDC", color: "#17750A" },
    Approved: { background: "#E0FCDC", color: "#17750A" },
    // Rejected
    rejected: { background: "#FCDCDD", color: "#7F0B0E" },
    Rejected: { background: "#FCDCDD", color: "#7F0B0E" },
    // Draft
    draft: { background: "#DCDCDC", color: "#364153" },
    Draft: { background: "#DCDCDC", color: "#364153" },
    // In Review
    in_review: { background: "#DEFEDB", color: "#0C6803" },
    "In Review": { background: "#DEFEDB", color: "#0C6803" },
    // Design In Progress
    design_in_progress: { background: "#DBDEFE", color: "#4C14E6" },
    "Design In Progress": { background: "#DBDEFE", color: "#4C14E6" },
    // Design Completed
    design_completed: { background: "#E0FCDC", color: "#17750A" },
    "Design Completed": { background: "#E0FCDC", color: "#17750A" },
    // Review In Progress
    review_in_progress: { background: "#F9DBFE", color: "#730486" },
    "Review In Progress": { background: "#F9DBFE", color: "#730486" },
    // Revision In Progress
    revision_in_progress: { background: "#1447E6", color: "#FFFFFF" },
    "Revision In Progress": { background: "#1447E6", color: "#FFFFFF" },
    //   Request Submitted
    request_submitted: { background: "#016630", color: "#FFFFFF" },
    "Request Submitted": { background: "#016630", color: "#FFFFFF" },
    //   Revision Requested
    revision_requested: { background: "#F7FCDC", color: "#61710A" },
    "Revision Requested": { background: "#F7FCDC", color: "#61710A" },
    // In Progress
    in_progress: { background: "#F7FCDC", color: "#61710A" },
    "In Progress": { background: "#F7FCDC", color: "#61710A" },
    // Cancelled
    cancelled: { background: "#FFCDCD", color: "#F00000" },
    Cancelled: { background: "#FFCDCD", color: "#F00000" },
    // Hold
    hold: { background: "#DBFBFE", color: "#048490" },
    Hold: { background: "#DBFBFE", color: "#048490" },
    // Deleted
    deleted: { background: "#FCDCDD", color: "#7F0B0E" },
    Deleted: { background: "#FCDCDD", color: "#7F0B0E" },
    // Completed
    completed: { background: "#E0FCDC", color: "#17750A" },
    Completed: { background: "#E0FCDC", color: "#17750A" },
    // Start Review
    start_review: { background: "#EEF2FF", color: "#4F46E5" },
    "Start Review": { background: "#EEF2FF", color: "#4F46E5" },
};
export const STATUS_FALLBACK = { background: "#f1f5f9", color: "#475569" };
